import React, { useMemo } from "react";
import WindowedSelect from "react-windowed-select";

const groupStyles = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
};
const groupBadgeStyles = {
  backgroundColor: "#EBECF0",
  borderRadius: "2em",
  color: "#172B4D",
  display: "inline-block",
  fontSize: 12,
  fontWeight: "normal",
  lineHeight: "1",
  minWidth: 1,
  padding: "0.16666666666667em 0.5em",
  textAlign: "center",
};

const formatGroupLabel = (data) => (
  <div style={groupStyles}>
    <span>{data.label}</span>
    <span style={groupBadgeStyles}>{data.options.length}</span>
  </div>
);

const GroupedTradingPartnerSelect = (props) => {
  const { tradingPartnerSelected, setTradingPartnerSelected, payers } = props;

  const mappedOptions = useMemo(
    () =>
      payers.map((payer) => ({
        label: `${payer.displayName} - ${payer.primaryPayerId}`,
        value: payer.primaryPayerId,
      })),
    [payers],
  );

  return (
    <WindowedSelect
      options={mappedOptions}
      value={tradingPartnerSelected}
      onChange={setTradingPartnerSelected}
      placeholder="Search trading partnert service"
      isClearable
    />
  );
};

export default GroupedTradingPartnerSelect;
